<mat-list-item
  [ngClass]="{ 'active-button': isActive() && !button.disabled }"
  class="text-center"
  (click)="onClick($event)"
>
  <!-- Content for expanded sidebar -->
  <div
    *ngIf="isExpanded"
    [ngClass]="{ 'text-gray-500': button.disabled }"
    class="flex flex-row gap-2 items-center"
  >
    <mat-icon [attr.aria-label]="button.name" class="align-middle cursor-pointer" mat-list-icon
      >{{ button.icon_name }}
    </mat-icon>
    <span
      [ngClass]="{ 'font-medium': isActive() }"
      class="text-sm ml-4"
      translate="{{ button.label }}"
    ></span>
  </div>

  <!-- Content for collapsed sidebar -->
  <div *ngIf="!isExpanded" [ngClass]="{ 'text-gray-500': button.disabled }">
    <mat-icon [attr.aria-label]="button.name" class="align-middle cursor-pointer" mat-list-icon
      >{{ button.icon_name }}
    </mat-icon>
  </div>
</mat-list-item>
